"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductTransactionType = void 0;
var ProductTransactionType;
(function (ProductTransactionType) {
    ProductTransactionType["SHIPPED"] = "shipped";
    ProductTransactionType["PACKAGED"] = "packaged";
    ProductTransactionType["RECEIVED"] = "received";
    ProductTransactionType["BUILT"] = "built";
    ProductTransactionType["MANUAL_ADJUSTMENT"] = "manual-adjustment";
    ProductTransactionType["NON_INVENTORY"] = "non-inventory";
    ProductTransactionType["ALLOCATED_FOR_PACKING"] = "allocated-for-packing";
})(ProductTransactionType = exports.ProductTransactionType || (exports.ProductTransactionType = {}));
//# sourceMappingURL=product-transaction-type.enum.js.map